import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, Legend } from "recharts";

import { outcomeLabel } from "@/lib/labels";

const COLORS = ["#2563EB", "#10B981", "#7C3AED", "#F59E0B", "#06B6D4", "#EF4444"];

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics").then(r => setData(r.data)); }, []);
  if (!data) return <div className="p-8 text-slate-500">Loading…</div>;

  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight">Analytics</h1>
      <p className="text-slate-600 mt-1">Your last 14 days.</p>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-white border border-slate-200 rounded-2xl p-6"><div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Total calls</div><div className="mt-2 text-3xl font-bold font-heading">{data.total_calls}</div></div>
        <div className="bg-white border border-slate-200 rounded-2xl p-6"><div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Total appointments</div><div className="mt-2 text-3xl font-bold font-heading">{data.total_appointments}</div></div>
        <div className="bg-white border border-slate-200 rounded-2xl p-6"><div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Booking conversion</div><div className="mt-2 text-3xl font-bold font-heading">{data.total_calls ? Math.round(100 * data.total_appointments / data.total_calls) : 0}%</div></div>
      </div>

      <div className="mt-6 grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white border border-slate-200 rounded-2xl p-6">
          <div className="font-heading font-semibold text-lg mb-4">Calls & appointments</div>
          <div className="h-72" data-testid="analytics-line-chart">
            <ResponsiveContainer>
              <LineChart data={data.daily}>
                <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip />
                <Line type="monotone" dataKey="calls" stroke="#2563EB" strokeWidth={2} />
                <Line type="monotone" dataKey="appointments" stroke="#10B981" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-2xl p-6">
          <div className="font-heading font-semibold text-lg mb-4">Call outcomes</div>
          <div className="h-72" data-testid="analytics-pie-chart">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={data.outcomes} dataKey="value" nameKey="name" outerRadius={80}>
                  {data.outcomes.map((o, i) => <Cell key={o.name || `outcome-${i}`} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Legend wrapperStyle={{ fontSize: 11 }} formatter={outcomeLabel} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
